import { useState, useEffect } from "react";
import { Category } from "../../../types/Category";
import { HttpCategory } from "../../../http";

export const useCategories = () => {
    const [categories, setCategories] = useState<Category[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    const fetchCategories = async () => {
        try {
            setLoading(true);
            setError(null);
            const data = await HttpCategory.getAllCategories();
            setCategories(data);
        } catch (err) {
            setError("Error al cargar las categorías");
            console.error("Error fetching categories:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCategories();
    }, []);

    const buildCategoryTree = (categories: Category[]) => {
        const categoryMap = new Map<number, Category & { subcategories: Category[] }>();

        categories.forEach((category) => {
            categoryMap.set(category.id, { ...category, subcategories: [] });
        });

        const tree: (Category & { subcategories: Category[] })[] = [];

        categories.forEach((category) => {
            const categoryWithChildren = categoryMap.get(category.id)!;

            if (category.idCategoriaPadre === null) {
                tree.push(categoryWithChildren);
            } else {
                const parent = categoryMap.get(category.idCategoriaPadre);
                if (parent) {
                    parent.subcategories.push(categoryWithChildren);
                }
            }
        });

        return tree;
    };

    const rootCategories = categories.filter((cat) => cat.idCategoriaPadre === null);

    const getSubcategories = (parentId: number) => {
        return categories.filter((cat) => cat.idCategoriaPadre === parentId);
    };

    return {
        categories,
        rootCategories,
        loading,
        error,
        refetch: fetchCategories,
        buildCategoryTree,
        getSubcategories,
    };
};
